import React from "react"
import { FaqListModule } from "../../carlsberg-headless/types/modules/FaqList"
import { FaqContentElement } from "../../carlsberg-headless/types/content-elements/Faq"
import { FlexCell, FlexRow } from "@shared-components/FlexGrid/FlexGrid"
import { Container } from "@shared-components/Container/Container"
import { Box } from "@shared-components/Box/Box"
import { faqItemStyle, faqItemTextStyle } from "./styles"
import { Heading } from "@shared-components/Heading/Heading"
import { Text } from "@shared-components/Text/Text"
import { ButtonLink } from "@shared-components/Button/Button"
import { useDictionaryContext } from "../../context/dictionary/useDictionaryContext"
import { useSiteContext } from "../../context/site/useSiteContext"
import { DICTIONARY_MAP } from "../../carlsberg-headless/dictionary-map"

export interface FaqListProps extends FaqListModule {
  questionText?: string
  answerText?: string
  buttonText?: string
}

export interface FaqListItemProps extends FaqContentElement {
  questionText?: string
  answerText?: string
  buttonText?: string
}

const FaqListItem: React.FC<FaqListItemProps> = ({ ...props }) => {
  return (
    <Box sx={faqItemStyle}>
      <Heading as="h3" variant="cardSectionText" sx={{ fontSize: "xsText" }}>
        {props.questionText}
      </Heading>
      <Text as="p" variant="h4" sx={faqItemTextStyle}>
        {props.question}
      </Text>
      <Heading as="h3" variant="cardSectionText" sx={{ fontSize: "xsText" }}>
        {props.answerText}
      </Heading>
      <Text as="p" sx={faqItemTextStyle}>
        {props.answer}
      </Text>
      {props.link && (
        <ButtonLink
          variant="copper"
          outline
          to={props.link.url}
          target={props.link.target ?? ""}
        >
          {props.buttonText ? props.buttonText : "Tell more"}
        </ButtonLink>
      )}
    </Box>
  )
}

const PureFaqList: React.FC<FaqListProps> = ({
  cbKey,
  faqs,
  questionText,
  answerText,
  buttonText,
}) => {
  if (!faqs) {
    return null
  }

  return (
    <Container key={cbKey} sx={{ maxWidth: "width.3" }}>
      <FlexRow spacing={[2, 2, 4]} sx={{ justifyContent: "center" }}>
        {faqs.map((faqItem: FaqListItemProps, index: number) => (
          <FlexCell col={[12, 6, 4]} key={`${cbKey}_${index}`}>
            <FaqListItem
              {...faqItem}
              questionText={questionText}
              answerText={answerText}
              buttonText={buttonText}
            />
          </FlexCell>
        ))}
      </FlexRow>
    </Container>
  )
}

const FaqList: React.FC<FaqListModule> = props => {
  const { get } = useDictionaryContext()
  const { currentCulture } = useSiteContext()
  return (
    <PureFaqList
      questionText={get(
        DICTIONARY_MAP.faq_module.faq_module_question_text,
        currentCulture
      )}
      answerText={get(
        DICTIONARY_MAP.faq_module.faq_module_answer_text,
        currentCulture
      )}
      buttonText={get(
        DICTIONARY_MAP.faq_module.faq_module_button_text,
        currentCulture
      )}
      {...props}
    />
  )
}

export { FaqList, PureFaqList }
